import React from 'react';
import { SPWClickAwayTooltip } from 'spw-shared/globalComponents';
import {
  SubtotalTooltipTitle,
  SubtotalTooltipText,
  DraggableTooltipContainer,
} from './styles';

const tooltip = (
  <DraggableTooltipContainer>
    <SubtotalTooltipTitle id="draggable-dialog-title" className="title">
      Rounding Tips
    </SubtotalTooltipTitle>
    <div className="content">
      <SubtotalTooltipText>
        Values may not total 100% since Space Plan Wizard does not round your
        values up or down.
      </SubtotalTooltipText>
      <SubtotalTooltipText>
        Use the Hide/Show decimals toggle to view fractional values.
      </SubtotalTooltipText>
      <SubtotalTooltipText>
        After using seat mix and target ratios as a guide, we recommend updating
        quantities with whole values, or else you may end up with fractional
        quantities in your program.
      </SubtotalTooltipText>
    </div>
  </DraggableTooltipContainer>
);

const ESTIMATED_WIDTH = 298;
const ESTIMATED_HEIGHT = 270;

export const WorkseatSubtotalTooltip = () => (
  <SPWClickAwayTooltip height={ESTIMATED_HEIGHT} width={ESTIMATED_WIDTH}>
    {tooltip}
  </SPWClickAwayTooltip>
);
